import React from 'react'
import PropTypes from 'prop-types'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { inject, observer } from 'mobx-react'

const BoardReportLayout = props => {
  const { children, title, aclStore } = props
  const { aclActionsByUser } = aclStore
  const pathName = window.location.pathname

  return (
    <DashboardLayout>
      {title}
      <ContentBlockWrapper>{children}</ContentBlockWrapper>
    </DashboardLayout>
  )
}

BoardReportLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  selectedKey: PropTypes.string,
}

export default inject('aclStore')(observer(BoardReportLayout))
